import { render, staticRenderFns } from "./Deviz_produse.vue?vue&type=template&id=7db8b412&scoped=true&"
import script from "./Deviz_produse.vue?vue&type=script&lang=js&"
export * from "./Deviz_produse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db8b412",
  null
  
)

export default component.exports